import React, { useEffect, useState } from 'react'
import './Showcase.css'
import close from '../../assests/closebuttonblack.png'
import ServiceFormInput from './ServiceFormInput'
import ServiceTerms from "./ServiceTerms";

const ServiceForm = ({ service, setServiceForm, orgDomain }) => {

  const [showTerms, setShowTerms] = useState(false);
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    }
  }, [])

  return (
    // w-[100%] h-[100%] absolute backdrop flex flex-col items-center justify-center
    <div className="max-w-[620px] w-[100%] h-[100%] fixed top-0 flex flex-col items-center justify-center serviceformbg backdrop-blur-xl z-[50] ">
      <div className="absolute top-0 w-[100%]">
        <div className="h-[1400px] overflow-x-hidden overflow-y-auto box relative">
          <div className="h-[1200px] max-w-[425px] min-w-[358px] mx-[3%] bg-[#FFFFFF] rounded-[20px] mt-10 mb-[800px]">
            <div className="w-[100%] h-[30%] relative rounded-t-[20px] overflow-hidden">
              <div
                className="absolute top-2 right-2 rounded-full bg-white h-[48px] w-[48px] flex justify-center items-center hover:cursor-pointer"
                onClick={() => setServiceForm(false)}
              >
                <img src={close} alt="" className="h-[16px] w-[16px] " />
              </div>
              <img
                src={service?.imageUrl}
                alt=""
                className="w-[100%] h-[100%] object-cover"
              />
              <div className="w-[100%] h-[149px] lg:h-[40%] absolute bottom-0 serviceformbanner flex flex-col items-center text-center justify-evenly px-[5%] py-[2%]">
                <p className="serviceformheading text-[21px] md:text-[32px]">
                  {service?.title}
                </p>
                <p className="servicedescription text-[14px] md:text-[16px]">
                  {service?.description}
                </p>
              </div>
            </div>
            <ServiceFormInput
              setServiceForm={setServiceForm}
              orgDomain={orgDomain}
              mail={service?.email}
              setShowTerms={setShowTerms}
            />
          </div>

        </div>
        {showTerms && <ServiceTerms setShowTerms={setShowTerms} />}
      </div>

    </div>
  )
}

export default ServiceForm
